import React, { Component } from 'react';
import { _Alert, variable, _post, _getToken, _isLogin, _setTime } from './Function';
import SideBar from './SideBar';
import Loading from './Loading';
import '../css/Guarantor.css';

class Guarantor extends Component {
    constructor(props) {
        super(props);
        this.state={ loadingShow: true, is_data: true, guarantor: [] };
        _isLogin().then( value => { 
            if ( value ) this.getGuarantor();
        });
    }

    getGuarantor = () => {
        let param = { token: _getToken(), platform: variable().platform };
        _post('get.loan.guarantee.php', param)
        .then(res => {
            if ( res.data.status ) {
                this.setState({ loadingShow: false, is_data: true, guarantor: res.data.data })
            } else {
                this.setState({ loadingShow: false, is_data: false })
                if ( res.data.responseText === 101 ) {
                    localStorage.clear();
                    _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
                }
            }
        }).catch(err => { 
            this.setState({ loadingShow: false })
            _Alert('error'); 
        });
    }

    randerGuarantor() {
        return(
            <div>
                {
                    this.state.guarantor.map((guaran, index) => (
                        <div key={index} className={(index === 0) ? 'guaran-loop is-first' : 'guaran-loop'}>
                            <div>
                                <div className="guaran-row"><span className="text-title">เลขสัญญากู้ : </span><span className="text-desc">{guaran.contract_number}</span></div>
                                <div className="guaran-row"><span className="text-title">สถานะ : </span><span className="text-desc">{guaran.loan_status}</span></div>
                            </div>
                            <div>
                                <div className="guaran-row"><span className="text-title">ชื่อผู้กู้ : </span><span className="text-desc">{guaran.loan_name}</span></div>
                                <div className="guaran-row"><span className="text-title">ยอดเงินกู้ : </span><span className="text-desc">{guaran.loan_amount} บาท</span></div>
                            </div>
                            <div>
                                <div className="guaran-row"><span className="text-title">เงินค้ำประกัน : </span><span className="text-desc">{guaran.guarantee_amount} บาท</span></div>
                                <div className="guaran-row"><span className="text-title">ยอดเงินกู้คงเหลือ : </span><span className="text-desc">{guaran.loan_amount_balance} บาท</span></div>
                            </div>
                        </div> 
                    ))
                }
            </div>
        )
    }

    onAddTime = () => { _setTime() }

    render() {
        return (
            <div className="fix-content content-bar-bigger" onClick={(e) => this.onAddTime()}>
                <Loading show={this.state.loadingShow} />
                <SideBar onRefresh={false} />
                <div className="content-bar">

                    <div className="card">
                        <div className="card-title">
                            <div className="card-icon"><i className="fas fa-user-shield"></i></div>
                            <div className="card-title-text">ภาระการค้ำประกัน</div>
                        </div>
                        <div className="card-content">
                            { (this.state.is_data) ? this.randerGuarantor() : <div className="no-data">ไม่พบภาระการค้ำประกัน</div> }
                        </div>
                    </div>
                
                </div>
            </div>
        );
    }
}

export default Guarantor;